export const useAdamRefreshToken = async () => {
  const runtimeConfig = useRuntimeConfig();

  const { getAdamAuthRefreshHeaders } = useAdamHeader();

  const { setNewTokens } = useAdamTokens();

  const retryCount = ref<number>(0);

  const retryDelayInc = 500;

  const retryDelay = ref<number>(retryDelayInc);

  const retryCountMax = 3;

  let data;
  const promiseTimeout = (delay) => {
    return new Promise<void>((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, delay);
    });
  };

  const retry = async (e) => {
    retryCount.value += 1;
    if (retryCount.value >= retryCountMax) throw e;
    await promiseTimeout(retryDelay.value);
    retryDelay.value += retryDelayInc;
    await fetch();
  };

  const fetch = async () => {
    globalThis.$logger.info('useAdamRefreshToken :: fetch');
    try {
      data = await (<any>$fetch('/refresh-token', {
        method: 'POST',
        baseURL: runtimeConfig.public.apiBase,
        headers: getAdamAuthRefreshHeaders(),
      }));
      setNewTokens(data);
    } catch (e) {
      if (e.response.status === 401) {
        globalThis.$logger.info(
          'useAdamRefreshToken :: 401 redirect to logout'
        );
        window.location.href = '/logout';
      } else if (e.response.status === 502) {
        await retry(e);
      }
    }
  };

  await fetch();

  return data;
};
